import Util from './../Util.js';

/**
  * Sends requests to the API
  */
async function API(url, method, body, params, jsonType, token, thirdParty) {
	let finalUrl = url;
	const finalParams = typeof params === 'string' || typeof params === 'number' ? params : {...params};
	let finalBody;;
	jsonType ? finalBody = { ...body } : finalBody = body;

	// Build request
	const req = {
		method: method.toUpperCase(),
		headers: {
		},
	};

	if (jsonType) {
		finalBody = JSON.stringify(finalBody);
		req.headers['Content-Type'] = 'application/json';
	}

	if (method !== 'GET' && finalBody) {
		req.body = finalBody;
	}

	if (token && !thirdParty) {
		req.headers.Authorization = `Bearer ${token}`;
	}

	// Add Endpoint Params
	let urlParams = '';
	if (finalParams) {
		// Object - eg. /recipes?title=this&cat=2
		if (typeof finalParams === 'object') {
			// Replace matching params in API routes eg. /recipes/{param}/foo
			Object.keys(finalParams).forEach(p => {
				if (finalUrl.includes(`{${p}}`)) {
					finalUrl = finalUrl.split(`{${p}}`).join(finalParams[p]);
					delete finalParams[p];
				}
			});

			// Add the rest of the params as a query string if any exist
			if (Object.keys(finalParams).length) {
				urlParams = `?${Util.serialize(finalParams)}`;
			}
		}

		// String or Number - eg. /recipes/23 | ?recipe=23
		else if (typeof finalParams === 'string' || typeof finalParams === 'number') {
			if (finalParams.includes('?')) {
				urlParams = `${finalParams}`;
			}
			else {
				urlParams = `/${finalParams}`;
			}
		}
	}

	finalUrl += urlParams;
	const response = await fetch(finalUrl, req);

	if ((!thirdParty && !response.ok) || response.status >= 300) {
		const jsonRes = await response.json();
		throw await jsonRes;
	}

	// No Content
	if (response.status === 204) {
		return { statusCode: 204, ok: true };
	}
	if (method === 'POST' && response.status === 200 && response.url === 'https://uat.vclinic.io/api/health-providers/5ebdb167abfafb0027488ca9/services/64648c2f08e78900b11f1574') {
		return { statusCode: 200, ok: true };
	}

	const jsonRes = await response.json();
	return await jsonRes;
}

/* Export ==================================================================== */
export default API;
